module.exports = __webpack_public_path__ + "img/use1.8fb079fe.png";